/** Single-flight draft save — concurrent autosave/manual save share one in-flight promise. */

export function createDraftSaveCoordinator() {
  let inFlight = null;

  async function runSave(saveFn) {
    if (inFlight) return inFlight;
    inFlight = Promise.resolve()
      .then(() => saveFn())
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  }

  return { runSave, isSaving: () => !!inFlight };
}
